import Vue from "vue";
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
// ElementUI 防止页面抖动
ElementUI.Dialog.props.lockScroll.default = false;

Vue.use(ElementUI);
